import { AxiosResponse } from 'axios';
import {
  RemoteExecutionServiceImpl,
  RemoteGETCallInputObject,
  RemotePOSTCallInputObject,
  ServerResponse,
} from '../../../remoteExecution/RemoteExecutionServiceImpl';
import { WorkTaskTemplateResponseDTO } from '../worktasks/WorkTaskTemplateInterfaces';
import {
  CreateJobberOnboardingTemplateRequestDTO,
  UpdateJobberOnboardingTemplateRequestDTO,
  UpdateJobberOnboardingTemplateTypeRequestDTO,
} from './JobberOnboardingTemplateAPIInterfaces';

const remoteCallObject = RemoteExecutionServiceImpl();
const backendApiBasePathLocal: string = process.env.REACT_APP_BACK_END_SERVER_BASE_PATH_LOCAL ?? '';

const JOBBER_ONBOARDING_TEMPLATE_BASE_PATH: string = `${backendApiBasePathLocal}v1/agency/jobber-onboarding-template`;

const CreateJobberOnboardingTemplateAPICall = async (
  createRequest: CreateJobberOnboardingTemplateRequestDTO
): Promise<WorkTaskTemplateResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<CreateJobberOnboardingTemplateRequestDTO> = {
    apiUrl: `${JOBBER_ONBOARDING_TEMPLATE_BASE_PATH}/create-jobber-onboarding-template`,
    headers: {},
    object: createRequest,
  };

  const response: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO, Error>> =
    await remoteCallObject.remotePOSTCallV2<
      ServerResponse<WorkTaskTemplateResponseDTO, Error>,
      CreateJobberOnboardingTemplateRequestDTO
    >(postCallInput);

  if (response?.data?.data) {
    return response.data.data;
  }

  return null;
};

const GetJobberOnboardingTemplatesAPICall = async (): Promise<WorkTaskTemplateResponseDTO[] | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${JOBBER_ONBOARDING_TEMPLATE_BASE_PATH}/jobber-onboarding-templates`,
    headers: {},
    queryParams: null,
  };

  const response: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO[], Error>> =
    await remoteCallObject.remoteGETCallV2<ServerResponse<WorkTaskTemplateResponseDTO[], Error>>(getCallInput);

  if (response?.data?.data) {
    return response.data.data;
  }

  return null;
};

const GetJobberOnboardingTemplateByIdAPICall = async (
  templateId: string
): Promise<WorkTaskTemplateResponseDTO | null> => {
  const getCallInput: RemoteGETCallInputObject = {
    apiUrl: `${JOBBER_ONBOARDING_TEMPLATE_BASE_PATH}/jobber-onboarding-template`,
    headers: {},
    queryParams: { templateId },
  };

  const response: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO, Error>> =
    await remoteCallObject.remoteGETCallV2<ServerResponse<WorkTaskTemplateResponseDTO, Error>>(getCallInput);

  if (response?.data?.data) {
    return response.data.data;
  }

  return null;
};

const UpdateJobberOnboardingTemplateAPICall = async (
  updateRequest: UpdateJobberOnboardingTemplateRequestDTO
): Promise<WorkTaskTemplateResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<UpdateJobberOnboardingTemplateRequestDTO> = {
    apiUrl: `${JOBBER_ONBOARDING_TEMPLATE_BASE_PATH}/update-jobber-onboarding-template`,
    headers: {},
    object: updateRequest,
  };

  const response: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO, Error>> =
    await remoteCallObject.remotePOSTCallV2<
      ServerResponse<WorkTaskTemplateResponseDTO, Error>,
      UpdateJobberOnboardingTemplateRequestDTO
    >(postCallInput);

  if (response?.data?.data) {
    return response.data.data;
  }

  return null;
};

/**
 * Updates only PRIMARY/SECONDARY role. Does not rewrite sections or bump templateVersion.
 */
const UpdateJobberOnboardingTemplateTypeAPICall = async (
  updateRequest: UpdateJobberOnboardingTemplateTypeRequestDTO
): Promise<WorkTaskTemplateResponseDTO | null> => {
  const postCallInput: RemotePOSTCallInputObject<UpdateJobberOnboardingTemplateTypeRequestDTO> = {
    apiUrl: `${JOBBER_ONBOARDING_TEMPLATE_BASE_PATH}/update-jobber-onboarding-template-type`,
    headers: {},
    object: updateRequest,
  };

  const response: AxiosResponse<ServerResponse<WorkTaskTemplateResponseDTO, Error>> =
    await remoteCallObject.remotePOSTCallV2<
      ServerResponse<WorkTaskTemplateResponseDTO, Error>,
      UpdateJobberOnboardingTemplateTypeRequestDTO
    >(postCallInput);

  if (response?.data?.data) {
    return response.data.data;
  }

  return null;
};

export {
  CreateJobberOnboardingTemplateAPICall,
  GetJobberOnboardingTemplatesAPICall,
  GetJobberOnboardingTemplateByIdAPICall,
  UpdateJobberOnboardingTemplateAPICall,
  UpdateJobberOnboardingTemplateTypeAPICall,
};
